// Revival: keep variant-specific content in sync with the selected variant.
// Horizon only re-renders price and buy buttons on option change, so blocks render one element per variant
// (inside [data-rv-variant-scope], each with data-rv-variant-id) and this script shows the selected one.
// The selected variant comes from the URL (?variant=) or the product form's hidden id input.
(function () {
  if (window.RevivalVariantSync) return;
  function currentId() {
    var q = new URLSearchParams(location.search).get('variant');
    if (q) return q;
    var input = document.querySelector('product-form-component input[name="id"]');
    return input ? input.value : '';
  }
  var last = null;
  function sync(force) {
    var id = currentId();
    if (!force && id === last) return;
    last = id;
    document.querySelectorAll('[data-rv-variant-scope]').forEach(function (scope) {
      var items = scope.querySelectorAll('[data-rv-variant-id]');
      if (!items.length || !id) return;
      items.forEach(function (el) { el.hidden = el.getAttribute('data-rv-variant-id') !== id; });
    });
    document.dispatchEvent(new CustomEvent('revival:variant', { detail: { id: id } }));
  }
  window.RevivalVariantSync = { sync: sync, currentId: currentId };
  document.addEventListener('change', function () { setTimeout(sync, 50); setTimeout(sync, 600); });
  window.addEventListener('popstate', function () { sync(); });
  setInterval(sync, 700);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { sync(true); });
  else sync(true);
})();
